import React from 'react';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import VrIcons from 'Components/Utility/VrIcons';
import { encodeSlug } from 'Helpers/Slug';
import meta from 'Components/FacetedFacetSearch/facetFilterMeta';
import 'Components/FacetedFacetSearch/VrSearchFilters.scss';

const VrSearchFilters = ({
  facetsGroupsArray,
  intl: { formatMessage },
  onChange,
}) => {
  const slug = 'vr-games';
  const metaObj = meta[slug];

  return (
    <nav data-nosnippet className="vr-search-filters-container">
      {facetsGroupsArray.map(segment =>
        <React.Fragment key={segment.name}>
          {segment.facets.filter(facet => facet.key !== 'vr_required').map(facet =>
            <div className="vr-search-filter-container" key={facet.key}>
              <Link
                to={`/${slug}/${encodeSlug(facet.key)}`}
                className="d-none"
              >
                {formatMessage(metaObj.language.title)} {facet.title}
              </Link>
              <label htmlFor={facet.key}>
                <div className={`vr-search-filter ${facet.key}`}>
                  <div className="checkbox-container">
                    <input
                      id={facet.key}
                      name={facet.key}
                      type="checkbox"
                      checked={facet.selected}
                      aria-label={facet.key}
                      onChange={onChange}
                    />
                  </div>
                  <div className="icon-container">
                    <VrIcons vrFeature={facet.key} />
                  </div>
                  <div className="filter-name-container ml-1">
                    {facet.title}
                  </div>
                </div>
              </label>
            </div>,
          )}
        </React.Fragment>,
      )}
    </nav>
  );
};

VrSearchFilters.propTypes = {
  facetsGroupsArray: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func.isRequired,
};

VrSearchFilters.defaultProps = {
  facetsGroupsArray: [],
};

export default injectIntl(VrSearchFilters);
